import { render, staticRenderFns } from "./StatisticalBar.vue?vue&type=template&id=488b0b04&scoped=true"
import script from "./StatisticalBar.vue?vue&type=script&lang=js"
export * from "./StatisticalBar.vue?vue&type=script&lang=js"
import style0 from "./StatisticalBar.vue?vue&type=style&index=0&id=488b0b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b0b04",
  null
  
)

export default component.exports